import { useGetBenefitDetail } from '@/common/integrations/menhir/employee/benefits/benefits.hooks';
import { IOperation } from '@/common/integrations/menhir/employee/operations/operations.types';
import { LearningCenter } from '@/web/containers/Benefits/ItalyBenefitsPage/components/LearningCenter/LearningCenter';
import { CreditsLearningCenter } from '@/web/containers/Credits/CreditsHome/components/CreditsLearningCenter/CreditsLearningCenter';
import { MealVoucherLearningCenter } from '@/web/containers/MealVoucher/components/LearningCenter/MealVoucherLearningCenter';

interface IOperationsLerningCenterProps {
  operation: IOperation;
  toggleLearningCentre: (open: boolean) => void;
}

export const OperationsLerningCenter = ({
  operation,
  toggleLearningCentre,
}: IOperationsLerningCenterProps) => {
  const { benefit } = useGetBenefitDetail(
    { slug: operation.categorySlug! },
    { enabled: !!operation.categorySlug }
  );

  const rejectionReason = operation.descriptionParams.find(
    (param) => param.key === 'rejection_reason'
  )?.value;

  if (!benefit) return null;

  if (benefit.slug === 'meals' && rejectionReason === 'not_enough_balance') {
    return (
      <CreditsLearningCenter onClose={() => toggleLearningCentre(false)} />
    );
  }

  if (benefit.slug === 'meals') {
    return (
      <MealVoucherLearningCenter
        onClose={() => toggleLearningCentre(false)}
        key={'buoni_pasto_learning_center'}
      />
    );
  }

  if (benefit.slug === 'fringe') {
    return (
      <LearningCenter
        benefit={benefit}
        toggleLearningCentre={toggleLearningCentre}
      />
    );
  }

  return null;
};
